import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IChannel } from 'src/app/models/interfaces/channel.interface';
import { ChannelDetailContext } from '../channel-detail-context';
import { ChannelFormComponent } from '../channel-form/channel-form.component';
import { AttributesAssignmentComponent } from '../tabs/attributes-assignment/attributes-assignment.component';
import { AutoLinkComponent } from '../tabs/auto-link/auto-link.component';
import { CustomerIdentificationComponent } from '../tabs/customer-identification/customer-identification.component';
import { DocumentTypeIdentificationComponent } from '../tabs/document-type-identification/document-type-identification.component';

@Component({
    selector: 'app-channel-detail',
    templateUrl: './channel-detail.component.html',
    styleUrls: ['./channel-detail.component.scss'],
    imports: [MatTabsModule, ChannelFormComponent, CustomerIdentificationComponent, DocumentTypeIdentificationComponent, AttributesAssignmentComponent, AutoLinkComponent]
})
export class ChannelDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public channelUpdated: EventEmitter<IChannel> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: ChannelDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<ChannelDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: ChannelDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param channel: Infos du canal de réception modifié.
     */
    public onChannelUpdated(channel: IChannel) {
        this.channelUpdated.emit(channel);
    }

    public onCustomerIdentificationsUpdated(channel: IChannel) {
        this.channelUpdated.emit(channel);
    }

    public onDocumentTypeIdentificationsUpdated(channel: IChannel) {
        this.channelUpdated.emit(channel);
    }

    public onAttributeAssignmentsUpdated(channel: IChannel) {
        this.channelUpdated.emit(channel);
    }

    public onAutoLinksUpdated(channel: IChannel) {
        this.channelUpdated.emit(channel);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
